<div *ngIf="inspection?.boxFolderId" style="width: 100%; height: 100vh">
  <app-box-picker
    [folderId]="inspection.boxFolderId"
    [options]="options"
    style="width: 100%; height: 100%"></app-box-picker>
</div>
